import React from 'react';
import propTypes from 'prop-types';
import mergeI18n from '../../lib/util/merge-i18n';
import i18n from './i18n';
import img from './csr.png';
import preloadImg from '../../lib/util/preload-img';
import Icon from '../icon/icon';

preloadImg(img);

class ContactUs extends React.Component {
	componentDidMount () {
		this.props.setParentState({
			progressIndex: -1,
			canLogOut: false,
			canGoToHomePage: true
		});
	}

	render () {
		const __ = mergeI18n(this.props.language, i18n);
		document.title = `${__.titleStem} - ${__.pageTitle}`;

		return (
			<div id='lss-content'>
				<div id='contact-us' className='container'>
					<div className='row'>
						<div className='col-xs-12 col-centered text-center'>
							<img className='csr-icon' src={img} alt='' />
							<h2 className='lss-blue'>
								{
									{
										[true]: __.dontPanic,
										[this.props.path === '/contact-us']: __.contactUs,
										[this.props.path === '/contact-finance-company']: __.contactFinanceCompany
									}.true
								}
							</h2>
						</div>
					</div>
					{this.props.path !== '/contact-finance-company' && <div className='row'>
						<div className='col-xs-12 col-centered text-center'>
							<h4>{__.pleaseContact}</h4>
						</div>
					</div>}
					{this.props.path !== '/contact-finance-company' && <div className='col-centered text-center contact-row'>
						<div className='contact-row row col-centered text-center'>
							<div className='contact-container'>
								<span className='link-wrapper'>
									<Icon name='MdPhone' />
									<a href={`tel:${__.callCenterPhone.replace(/\D/g, '')}`}>{__.callCenterPhone}</a>
								</span>
								<span className='link-wrapper'>
									<Icon name='MdEmail' />
									<a href={`mailto:${__.callCenterEmail}`}>{__.callCenterEmail}</a>
								</span>
							</div>
						</div>
					</div>}
					{this.props.path !== '/contact-finance-company' && <div className='row'>
						<div className='col-xs-12 col-centered text-center'>
							<div id='hours' className='hours lss-dark-grey'>{__.callCenterHours}</div>
						</div>
					</div>}
				</div>
			</div>
		);
	}
}

ContactUs.propTypes = {
	language: propTypes.string.isRequired,
	path: propTypes.string.isRequired
};
export default ContactUs;
